import { FC } from 'react';
import transformCondition from '@app/helpers/transformCondition';
import { Condition } from '@__generated__/globalTypes';
import ProductList from '../ProductList';
import ProductPlaceholders from '../ProductPlaceholders';
import UserWrapper from '../../UserWrapper';
import ProtectedContent from '../ProtectedContent';
import ErrorContent from '../ErrorContent';
import { FinderState } from '../url';

const ProductListWrapper: FC<{
  isPageProtected: boolean;
  condition: Condition | null;
  language: string;
  searchState: FinderState;
}> = ({ isPageProtected, condition, language, searchState }) => {
  const ProductListWithCondition: FC<{
    transformedCondition?: Condition | null;
  }> = ({ transformedCondition }) => (
    <ProductList
      condition={transformedCondition ?? condition}
      language={language}
      searchState={searchState}
    />
  );

  return isPageProtected ? (
    <UserWrapper>
      {({ loading, error, isAuthenticated, registrations }) => {
        if (loading) {
          return <ProductPlaceholders count={4} />;
        }
        if (error) {
          return <ErrorContent />;
        }
        if (!isAuthenticated) {
          return <ProtectedContent />;
        }

        const transformedCondition = registrations.length
          ? transformCondition(condition, {
              '{CUSTOMER_REGISTRATION_IDS}': registrations,
            })
          : condition;

        return (
          <ProductListWithCondition
            transformedCondition={transformedCondition}
          />
        );
      }}
    </UserWrapper>
  ) : (
    <ProductListWithCondition />
  );
};

export default ProductListWrapper;
